/**
 * Double Submit Cookie 方式の CSRF 対策用に、
 * Cookie から csrf_token の値を読み取って返します。
 * @returns {string} CSRF トークン文字列。Cookie が存在しない場合は空文字。
 */
export function getCsrfTokenFromCookie() {
  const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}
